import first from 'lodash/first';
import flatten from 'lodash/flatten';
import shuffle from 'lodash/shuffle';
import sortBy from 'lodash/sortBy';
import { createSelector } from 'reselect';

import { RootState } from 'src/config/rootStore';
import { MeditationNode } from 'src/generated/webapp_gql';

export const getMeditationCategories = (state: RootState) => state.meditation.meditationCategories;

export const getAllMeditations = createSelector(getMeditationCategories, categories =>
    categories ? flatten(categories.map(category => category.meditations)) : [],
);

export const getRecommendedMeditations = createSelector(getAllMeditations, meditations => {
    const sleepMantraMeditationId = process.env.REACT_APP_ENV === 'production' ? 44 : 25;
    const readyToCompletedATaskMeditationId = process.env.REACT_APP_ENV === 'production' ? 56 : 9;

    const recommendedIDs = [sleepMantraMeditationId, readyToCompletedATaskMeditationId];

    return meditations.filter(meditation => recommendedIDs.includes(meditation.id));
});

export const getSortedMeditations = createSelector(getAllMeditations, meditations =>
    sortBy(meditations, ['defaultOrdering', 'name']),
);

export const getFirstFiveMeditations = createSelector(getSortedMeditations, meditations =>
    meditations.slice(0, 5),
);

export const getRecommendedMeditationSlug = createSelector(getFirstFiveMeditations, meditations => {
    const meditation = first(shuffle(meditations));

    return meditation ? meditation.slug : '';
});

// turn the list of meditations into a hash for faster lookup
export const getMeditationsMap = createSelector(getMeditationCategories, meditationCategories => {
    if (!meditationCategories) {
        return {};
    }

    const meditationMap = {};

    meditationCategories.forEach(medCategory => {
        medCategory.meditations.forEach(med => {
            meditationMap[med.id] = med;
        });
    });

    return meditationMap;
});

export const getMeditationByName = createSelector(
    getMeditationsMap,
    (_, name) => name,
    (meditationsMap, name) => {
        const meditations: MeditationNode[] = Object.values(meditationsMap);

        return meditations.find(meditation => meditation.name.toLowerCase() == name.toLowerCase());
    },
);
